import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { ngForFadeInOpacity, ngForFadeInOut } from 'src/app/animations';
import { ExpandableCheckboxListItem } from 'src/app/core/models/i-expandable-checkbox-list-item';

@Component({
  selector: 'app-expandable-checkbox-list',
  templateUrl: './expandable-checkbox-list.component.html',
  styleUrls: ['./expandable-checkbox-list.component.scss'],
  animations: [ngForFadeInOpacity, ngForFadeInOut],
})
export class ExpandableCheckboxListComponent implements OnInit, OnChanges {
  @Input() title = 'Section';
  @Input() iconClass: string;
  @Input() metadata: ExpandableCheckboxListItem[];
  @Input() formGroup: UntypedFormGroup;
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
  @Output() onItemChecked = new EventEmitter<string>();
  @Output() onItemUnchecked = new EventEmitter<string>();

  isExpanded = true;
  selectedItems: ExpandableCheckboxListItem[] = [];
  memoMetadataMap = {};

  constructor() {}

  ngOnInit(): void {
    this.isExpanded = this.isExpandedByDefault;
    this._populateSelectedItems(this.formGroup);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formGroup?.currentValue) {
      this._populateSelectedItems(changes.formGroup.currentValue);
      this.formGroup = changes.formGroup.currentValue;
    }
    if (changes.metadata?.currentValue) {
      this.metadata = changes.metadata.currentValue;
      this._populateSelectedItems(this.formGroup);
    }
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  onOptionChange({ source, checked }: MatCheckboxChange): void {
    if (checked) {
      let item = this._getControlMetadata(source?.name);
      this.selectedItems = [...this.selectedItems, item];
      this.onItemChecked.emit(item.id);
    } else {
      let item = this._getControlMetadata(source?.name);
      this.selectedItems = [
        ...this.selectedItems.filter((si) => si.id !== item.id),
      ];
      this.onItemUnchecked.emit(item.id);
    }
  }

  getControlLabel(controlKey: string): string {
    this._updateMemoValues(controlKey);
    return this.memoMetadataMap[controlKey].label;
  }

  private _getControlMetadata(controlKey: string): ExpandableCheckboxListItem {
    return this.metadata?.find((m) => m.id === controlKey);
  }

  private _populateSelectedItems(newFormGroup: UntypedFormGroup): void {
    const selectedItemsKeys = [];
    Object.keys(newFormGroup.controls).forEach((controlKey) => {
      // tslint:disable-next-line:no-unused-expression
      newFormGroup.controls[controlKey].value &&
        selectedItemsKeys.push(controlKey);
    });

    this.selectedItems = [
      ...(this.metadata?.filter((m) => selectedItemsKeys.includes(m.id)) ?? []),
    ];
  }

  private _updateMemoValues(controlKey: string): void {
    this.memoMetadataMap = {
      ...this.memoMetadataMap,
      [controlKey]: this._getControlMetadata(controlKey),
    };
  }
}
